module.exports = __webpack_public_path__ + "img/245.Kindness_sensitivity.f43dcc43.svg";